const webSiteMarkupSchema = () => {
  const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL;
  return {
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    url: `${SITE_URL}`,
    name: 'Quran Pro',
    description:
      'Quran Pro platform is a collection of the best Quran reciters in the world, an amazing user interface design, and the best set of features. Download the Quran Pro for iOS and Android to enjoy a full experience',
    publisher: {
      '@id': `${SITE_URL}/#organization`,
    },
    inLanguage: 'en-US',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${SITE_URL}/search?search={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };
};

export default webSiteMarkupSchema;
